export default __webpack_public_path__ + "static/media/autoKey.c81582c4.svg";